module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-442.f2d8f6e.woff2";